// get data from api
export const GET_OFFERS_ALL = 'GET_OFFERS_ALL';
export const GET_OFFER = 'GET_OFFER';
export const GET_OFFERS_SEARCH = 'GET_OFFERS_SEARCH';
export const GET_CUSTOMER_DATA = 'GET_CUSTOMER_DATA';
export const GET_OPPORTUNITIES = 'GET_OPPORTUNITIES';
export const GET_CONST_VALUE = 'GET_CONST_VALUE';
export const GET_DASHBOARD_OFFERS = 'GET_DASHBOARD_OFFERS';
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';

// set data in store
export const SET_CUSTOMER_DATA = 'SET_CUSTOMER_DATA';
export const SET_OFFER = 'SET_OFFER';
export const SET_OFFERS = 'SET_OFFERS';
export const SET_CHART_OFFERS = 'SET_CHART_OFFERS';
export const SET_OPPORTUNITIES = 'SET_OPPORTUNITIES';

// reset data in store
export const OFFER_RESET = 'OFFER_RESET';
export const OFFER_RESET_ALL = 'OFFER_RESET_ALL';

// save data in db (api)
export const OFFER_SAVE = 'OFFER_SAVE';
export const OFFER_UPDATE = 'OFFER_UPDATE';

// handle errors > to be DEPRECATED with API saga/hook
export const OFFERS_ERROR = 'OFFERS_ERROR';
export const OFFER_CLEAR_ERROR = 'OFFER_CLEAR_ERROR';

export const OFFER_CALCULATE = 'OFFER_CALCULATE';
export const OFFER_CALCULATE_SUCCESS = 'OFFER_CALCULATE_SUCCESS';
export const OFFER_CALCULATE_RESET = 'OFFER_CALCULATE_RESET';

export const LOCK_OFFER_FORM = 'LOCK_OFFER_FORM';
export const UNLOCK_OFFER_FORM = 'UNLOCK_OFFER_FORM';
export const UNLOCK_OFFER = 'UNLOCK_OFFER';

export const UPLOAD_ATTACH = 'UPLOAD_ATTACH';
export const DOWNLOAD_ATTACH = 'DOWNLOAD_ATTACH';
export const DELETE_ATTACH = 'DELETE_ATTACH';
export const SET_OFFER_FILES = 'SET_OFFER_FILES';
export const PREP_FILE_DOWNLOAD_SUCCESS = 'PREP_FILE_DOWNLOAD_SUCCESS';
export const SEND_PROPOSAL = 'SEND_PROPOSAL';
